<div
  style="
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-left: 6px;
  "
>
  @if (event.overdue > 0) {
    <div
      class="overdue-label"
      style="
        min-height: 8px;
        height: 8px;
        border-radius: 40px;
        width: 8px;
        min-width: 8px;
        margin-right: 6px;
      "
    ></div>
  }
  @if (event.TechnicianNames.length > 1) {
    <div
      class="multi-tech-label"
      style="
        min-height: 8px;
        height: 8px;
        border-radius: 40px;
        width: 8px;
        min-width: 8px;
      "
    ></div>
  }
</div>
<div class="eventDescription" style="padding: 0px 0px 0px 4px; width: 100%">
  <div class="eventTime" style="width: 50%">
    {{ event.StartTime | moment: 'HH:mm' }} -
    {{ event.EndTime | moment: 'HH:mm' }}
  </div>
  @if (event.postcode) {
    <div class="eventPostCode" style="width: 50%; text-align: right">
      {{ event.postcode }}
    </div>
  }
  <div style="margin-right: 6px">
    <app-calendar-event-icons [event]="event" />
  </div>
</div>
